import React, { useEffect } from "react";
import HomeGlobalThree from "../../../mirai-home/HomeGlobalThree";

const japanDesk = [
  { id: "1", country: "United States" },
  { id: "2", country: "Dalian, China" },
  { id: "3", country: "Taiwan" },
  { id: "4", country: "Hong Kong S.A.R" },
  { id: "5", country: "Myanmar" },
  { id: "6", country: "Philippines" },
  { id: "7", country: "Cambodia" },
  { id: "8", country: "Indonesia" },
  { id: "9", country: "Nepal" },
  { id: "10", country: "India" },
  { id: "11", country: "Sri Lanka" }
];


const GroupCompany = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  return (
    <div>
      <div className="text-justify lg:pt-20 sm:py-5 min-h-screen border-t border-blue-200">
        <div className="text-justify w-full  max-w-screen-2xl mx-auto p-4 ">
          <h1 className="text-justify lg:text-5xl sm:text-2xl font-semibold font-jost customBlue">
            Group Company
          </h1>
          <div className="text-justify mt-2">
          <h1 className="text-justify text-2xl mt-10  font-jost text-gray-900">
          MIRAI Consulting Inc.
            </h1>
            <div className="text-justify mt-5">
           
              <table className="font-jost text-md">
                  <tr>
                      <td>
                         Company Name
                      </td>
                      <td>
                         MIRAI Consulting Inc.
                      </td>
                  </tr>
                  <tr>
                      <td>Representative</td>
                      <td>Mitsuo Kubo Atsushi Okada</td>
                  </tr>
                  <tr>
                      <td>Establishment</td>
                      <td>April 6, 1987</td>
                  </tr>
                  <tr>
                      <td>URL</td>
                      <td>https://www.miraic.jp/</td>
                  </tr>
                  <tr>
                      <td>Number of Employees</td>
                      <td>Domestic: Approx. 250 people
                      International: Approx. 100 people</td>
                  </tr>
                  <tr>
                      <td>Headquarter</td>
                      <td>19th floor, Kyobashi Edogrand, 2-2-1 Kyobashi, Chuo-ku, Tokyo 104-0031</td>
                  </tr>
              </table>
            </div>
          </div>
          <h1 className="text-justify text-2xl mt-10  font-jost text-gray-900">
            History
          </h1>
          <div className="text-justify mt-5">
            <p className="text-justify text-lg font-jost text-gray-600">
              Mirai Consulting’s journey began in April 1987 as a small but
              ambitious firm called Business Advisor Co. Ltd., with only Five
              Million Yen and a vision to provide specialized consulting
              services in information processing. From this modest beginning,
              the company evolved rapidly, launching a customer development team
              “Chuo Shinko Associates” in 1989 and later moving to Toranomon,
              Minato-ku, Tokyo, with increased capital, rebranding as C.S.A. Co.
              Ltd., laying the foundation for future growth.
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              In January 1996, the company expanded into tax advisory services
              by establishing the Keishi Suzuki Certified Public Accountant and
              Tax Accountant Office, which later became Mirai Consulting Tax
              Corporation.
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              In April 2000, the name changed to Chuo Consulting Co. Ltd.,
              marking a new chapter as a proud subsidiary of ChuoAoyama Audit
              Corporation (now Misuzu Audit Corporation). Two years later, in
              November 2002, it was rebranded as ChuoAoyama PwC Consulting Co.
              Ltd., reflecting its growing presence and ambitions.
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              By July 2005, the company expanded into tax services by creating
              the Tokyo Kasumigaseki Tax Corporation, which would later evolve
              into the Mirai Consulting Tax Corporation. In March 2006, the
              Tokyo International Certified Social Insurance and Labor
              Consultant Corporation was established, which laid the foundation
              for our future labor consulting services. In October 2006, the
              company rebranded once more, becoming Misuzu Consulting Co. Ltd.,
              setting the stage for the future of Mirai Consulting.
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              In April 2007, the company took a significant step forward,
              acquired shares from Misuzu Audit Corporation, rebranded as Mirai
              Consulting Co. Ltd., and by July 2007 formed the Mirai Consulting
              Group consisting of Mirai Consulting Co., Ltd., Mirai Consulting
              Tax Corporation, and Mirai Consulting Certified Social Insurance
              and Labor Consultant Corporation. This marked a new chapter in the
              company’s journey, allowing it to offer a wider range of services,
              from tax and social insurance consulting to business strategy.
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              Over the next few years, Mirai Consulting has steadily grown its
              footprint across Japan. The company opened new offices in major
              cities, starting with the Osaka office in April 2008, followed by
              Nagoya in 2009, Sapporo in 2012, Fukuoka in 2012, Hiroshima and
              Niigata in 2014, Sendai in 2015, and Okayama in 2015. Between 2016
              and 2024, additional offices were established in Okinawa, Morioka,
              Koriyama (Fukushima), Hachinohe, Saitama, Toyama, Kyoto,
              Asahikawa, Kitakyushu, Fukushima, Hamamatsu, Kawagoe and Matsue.
              Each new branch helped strengthen Mirai's commitment to providing
              localized support to businesses nationwide.
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              During this period, Mirai also strengthened its services by
              joining the Samurai Associates Group in 2012 and establishing
              Mirai Outsourcing SR Co., Ltd. in 2014 to enhance its outsourcing
              capabilities. Between 2016 and 2019, MCA Audit Corporation (later
              Mirai Sosei Audit Corporation), Mirai Value Creative Co., Ltd,
              Mobile Force Co., Ltd, MIRAI CONNECT Co., Ltd. (later Mirai HR
              Co., Ltd.) and Mirai Innovation Center Shibuya were also
              established. Each office was established with the goal of better
              serving our clients and staying close to the communities we work
              in.{" "}
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              In 2020, Mirai expanded its digital footprint by establishing
              Digital Force Co., Ltd., Digital Force Tax Corporation, Digital
              Force Certified Social Insurance and Labor Consultant Corporation,
              and Digital Force Judicial Scrivener Corporation. Waraji ee Co.,
              Ltd. and Mirai Business Lab General Incorporated Association were
              also established in the same year.{" "}
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              Mirai Co-Creation Holdings Co., Ltd was established in 2021 to
              innovate group management, including existing entities alongside
              Hokkaido Regional Revitalization Platform Co., Ltd., Nishinihon
              Regional Co-Creation Co., Ltd., and Kyushu Growth Lab Co., Ltd. To
              further strengthen group management, Tohoku Mirai Co-Creation Co.,
              Ltd., Tomoni Tsukuru Tokai Co., Ltd., and Fukushima Regional
              Co-Creation Consortium Co., Ltd. were founded in 2022.{" "}
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              Our global expansion began in 2011 with the creation of Weilai
              Enterprise Management Consulting in Shanghai. Excited by the
              potential in China, it quickly followed up with branches in
              Beijing and Shenzhen. In 2016, MIRAI Consulting set foot into
              ASEAN countries by establishing the local entity "MIRAI CONSULTING
              MALAYSIA SDN. BHD." in Kuala Lumpur, Malaysia. The firm later
              extended its global reach to Ho Chi Minh City in 2018 as Nippon
              MIRAI Company Limited. In 2019 the company expanded to Singapore
              as MIRAI Consulting SG Pte. Ltd. in Cecil Court, and MIRAI
              COACHING Co., Ltd. and in Thailand "Mirai Wealth Co., Ltd. and
              MIRAI CONSULTING (THAILAND) Co., Ltd. MIRAI Consulting Bangladesh
              Ltd." in Dhaka, Bangladesh started its journey in July 2024.
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              MIRAI also participated in capital investments FDI Accounting and
              Advisory Co., Ltd. in Bangkok, Thailand, Shanghai Manyi Enterprise
              Management Consulting Co., Ltd in 2019, and AIC VIETNAM CO., LTD
              in 2024.
            </p>
            <p className="text-justify text-lg font-jost text-gray-600 mt-10">
              With bigger and more ambitious plans for the future, Mirai
              Consulting continues its journey in an ever-changing business
              landscape, being guided by the same core principles of innovation,
              collaboration, and excellence that have driven its success for
              over three decades.
            </p>
          </div>
          <div className="lg:py-10 sm:py-5">
          <h1 className="text-justify text-2xl mt-10  font-jost text-gray-900">Japan Desk</h1>
          <div className="grid lg:grid-cols-4 sm:grid-cols-1 gap-5 mt-5">
            {
              japanDesk.map(desk=>
                <div className="w-full ">
                   <h1 className="lg:text-xl sm:text-md font-jost text-blue-500">{desk.country}<span className="text-gray-500">_japan Desk</span></h1>
                </div>
              )
            }
          </div>
        </div>
        </div>
        
        <HomeGlobalThree></HomeGlobalThree>
      </div>
    </div>
  );
};

export default GroupCompany;
